import { StoreDataSchema } from "./store.data";

/**
 * Version number for the Plugin Store Model schema
 */
export type PluginModelVersion = 0;

/**
 * Plugin-specific data stored in the vault
 */
export interface IPluginStoreData {
  /**
   * **Plugin Name**
   *
   * The name associated with this plugin
   */
  nm: string;

  /**
   * **Key ID**
   *
   * The linked key ID associated with this plugin, used to reference the API key for authentication when executing the plugin
   */
  kid: string;

  /**
   * **Plugin URL**
   *
   * The URL endpoint for the plugin, used to execute the plugin's functionality. This field is optional and may be populated based on the plugin's configuration.
   */
  url: string;

  /**
   * **Options**
   *
   * JSON-serialized, plugin-specific settings blob (e.g. the Transfers &
   * Conversions feature's enable flag and detection window). Optional and
   * additive - rows written before this field existed simply omit it and read
   * back as `undefined`, so no schema version bump is required.
   */
  opt?: string;
}

/**
 * Plugin Store Model Schema
 *
 * Represents a plugin stored in the vault with associated metadata
 */
export type PluginStoreModel = StoreDataSchema<PluginModelVersion, IPluginStoreData>;

/**
 * Default values for a new Plugin Store Model instance
 */
export const DefaultPluginStoreModel: PluginStoreModel = {
  id: "",
  dc: "",
  dm: "",
  v: 0,
  vid: "",
  nm: "",
  kid: "",
  url: "",
};
